const getSummaryCategoryData = (state) => (payload) => {
  const { type } = payload;
  const { dataFormat } = payload;
  const categoryDataArray = [];

  Object.entries(state.summaryChartData).forEach(
    (keyDatapointAsArray) => {
      const datapoint = keyDatapointAsArray[1];
      categoryDataArray.push(datapoint.flagCategoriesData[type][dataFormat]);
    },
  );
  return categoryDataArray;
};

const getSummaryFlagBreakDownData = (state) => (payload) => {
  const { dataFormat } = payload;
  const flagBreakDownDataArray = [];

  Object.entries(state.summaryChartData).forEach(
    (keyDatapointAsArray) => {
      const datapoint = keyDatapointAsArray[1];
      const objectToPush = [
        datapoint.flagBreakdownData[5][dataFormat],
        datapoint.flagBreakdownData[4][dataFormat],
        datapoint.flagBreakdownData[3][dataFormat],
        datapoint.flagBreakdownData[2][dataFormat],
        datapoint.flagBreakdownData[1][dataFormat],
        datapoint.flagBreakdownData[0][dataFormat],
      ];
      flagBreakDownDataArray.push(objectToPush);
    },
  );
  return flagBreakDownDataArray;
};

const getSummaryOnePlusFlagData = (state) => (dataFormat) => {
  const getOnePlusFlagDataArray = [];
  Object.entries(state.summaryChartData).forEach(
    (keyDatapointAsArray) => {
      const datapoint = keyDatapointAsArray[1];
      getOnePlusFlagDataArray.push(datapoint.onePlusFlagData['1+ flagged applications'][dataFormat]);
    },
  );
  return getOnePlusFlagDataArray;
};

const getSummarySingleMetricData = (state) => (payload) => {
  const { type } = payload;
  const { dataFormat } = payload;
  const singleMetricDataArray = [];

  Object.entries(state.summaryChartData).forEach(
    (keyDatapointAsArray) => {
      const datapoint = keyDatapointAsArray[1];
      singleMetricDataArray.push(
        datapoint.disadvantageBreakdownData[type][dataFormat],
      );
    },
  );
  return singleMetricDataArray;
};

const summaryPageMaxPercent = (state) => state.summaryPageMaxPercent;
const summaryPageMaxDecimalBase = (state) => state.summaryPageMaxDecimalBase;
const summaryPageMaxDecimalComp = (state) => state.summaryPageMaxDecimalComp;
const summaryPageMaxDecimalOverall = (state) => state.summaryPageMaxDecimalOverall;

export default {
  getSummaryCategoryData,
  getSummaryFlagBreakDownData,
  getSummaryOnePlusFlagData,
  getSummarySingleMetricData,
  summaryPageMaxPercent,
  summaryPageMaxDecimalBase,
  summaryPageMaxDecimalComp,
  summaryPageMaxDecimalOverall,
};
